export enum EventType {
  Dividend = 'Dividend',
  Earning = 'Earning',
  Ipo = 'IPO',
}
